import React from "react";
import style from "./acupuncture.module.scss";
import acupun1 from "./img/acupun_1.webp";
import acupun1_md from "./img/acupun_1_md.webp";
import acupun1_lg from "./img/acupun_1_lg.webp";
import acupun1_xl from "./img/acupun_1_xl.webp";

import acupun1_png from "./img/acupun_1.png";
import acupun1_md_png from "./img/acupun_1_md.png";
import acupun1_lg_png from "./img/acupun_1_lg.png";
import acupun1_xl_png from "./img/acupun_1_xl.png";

import acupun2 from "./img/acupun_2.webp";
import acupun2_md from "./img/acupun_2_md.webp";
import acupun2_lg from "./img/acupun_2_lg.webp";
import acupun2_xl from "./img/acupun_2_xl.webp";

import acupun2_png from "./img/acupun_2.png";
import acupun2_md_png from "./img/acupun_2_md.png";
import acupun2_lg_png from "./img/acupun_2_lg.png";
import acupun2_xl_png from "./img/acupun_2_xl.png";


function Acupuncture() {

  return (
    <div className={style.acupuncture} id="acupuncture">
      <div className="container">

        <h2 className={style.acupunctureTitle}>ACUPUNCTURE FOR HEALTH & WELLNESS</h2>

        <div className={style.acupunctureItemReverse}>
          <picture>
            <source media="(min-width: 1140px)" srcSet={acupun1_xl} type="image/webp"/>
            <source media="(min-width: 1140px)" srcSet={acupun1_xl_png} type="image/png"/>

            <source media="(min-width: 960px)" srcSet={acupun1_lg} type="image/webp"/>
            <source media="(min-width: 960px)" srcSet={acupun1_lg_png} type="image/png"/>

            <source media="(min-width: 720px)" srcSet={acupun1_md} type="image/webp"/>
            <source media="(min-width: 720px)" srcSet={acupun1_md_png} type="image/png"/>


            <source media="(max-width: 719px)" srcSet={acupun1} type="image/webp"/>
            <img className={style.acupunctureItem__imgReverse} src={acupun1_png} alt="acupuncture" width="320px" height="316px"/>
          </picture>
          <div className={style.acupunctureItem__textReverse}>
            <p>Our busy 24/7 modern day living pushes our body and mind to the limit. We keep going, always on, always
              working, eating on the go, worrying about our families, jobs, and finances. We push through the pain,
              don’t take sick days, and act as if we are immortal. As a result, the incidence of high blood pressure,
              heart disease, Type 2 diabetes, auto-immune disorders, anxiety, depression, insomnia are all on the rise.
            </p>
          </div>
          <div className="clearfix"/>
        </div>

        <div className={style.acupunctureItem}>
          <picture>
            <source media="(min-width: 1140px)" srcSet={acupun2_xl} type="image/webp"/>
            <source media="(min-width: 1140px)" srcSet={acupun2_xl_png} type="image/png"/>

            <source media="(min-width: 960px)" srcSet={acupun2_lg} type="image/webp"/>
            <source media="(min-width: 960px)" srcSet={acupun2_lg_png} type="image/png"/>

            <source media="(min-width: 720px)" srcSet={acupun2_md} type="image/webp"/>
            <source media="(min-width: 720px)" srcSet={acupun2_md_png} type="image/png"/>


            <source media="(max-width: 719px)" srcSet={acupun2} type="image/webp"/>
            <img className={style.acupunctureItem__img} src={acupun2_png} alt="second acupuncture" width="294px" height="350px"/>
          </picture>
          <div className={style.acupunctureItem__text}>
          <p>We are lucky to live in the country where we have access to top
            notch diagnostic medicine, but not everything can be fixed with a pill or surgery. Some successful Western
            treatments have side effects that are difficult to bear. There are also times when patients feel horribly
            sick and all western medicine tests tell them that there is nothing is wrong with them.
            </p>
            <br/>
            <p>That is where Traditional Chinese Medicine can be of tremendous help.  Our bodies have an amazing capacity for self-healing.  Acupuncture can help tap into your body’s ability to do so.
            </p>
          </div>
        </div>
        <div className="clearfix"/>
      </div>
    </div>
  )
}

export default Acupuncture;